import React, { useEffect } from "react";
import SearchBar from "../../tools/SearchBar";
import Dropdown from "../../global/Dropdown";
import { Filter } from "lucide-react";


export default function Reviews() {
  const filterByRatingOption = [
    { label: "1 Star", value: "1" },
    { label: "2 Stars", value: "2" },
    { label: "3 Stars", value: "3" },
    { label: "4 Stars", value: "4" },
    { label: "5 Stars", value: "5" },
  ];

  const filterByTimeOption = [
    { label: "1 Star", value: "1" },
    { label: "2 Stars", value: "2" },
    { label: "3 Stars", value: "3" },
    { label: "4 Stars", value: "4" },
    { label: "5 Stars", value: "5" },
  ];

  const getReviewsData = async () => {};

  useEffect(() => {
    getReviewsData();
  }, []);

  return (
    <div className="p-4 flex flex-col">
      <div className="flex items-center space-x-2">
        <SearchBar value={""} className="min-w-100 " onChange={() => {}} />
        <div className="ml-auto flex items-center space-x-3 dark:text-slate-400 text-slate-500">
          <Filter className="" />
          <Dropdown
            className="text-xs "
            placeholder="All Rating"
            options={filterByRatingOption}
          />
          <Dropdown
            className="text-xs "
            placeholder="Newest First"
            options={filterByTimeOption}
          />
        </div>
      </div>
    </div>
  );
}
